module.exports = __webpack_public_path__ + "static/media/logo.a585e5b7.png";